// extracted by mini-css-extract-plugin
module.exports = {"content":"Login_content__1gsZ9","loginBox":"Login_loginBox__3oDxH","loginAndRegis":"Login_loginAndRegis__3Xyye"};